const doc = [({"da":({"js":({"admin":({"subscriptions":({"show":({"show_subscription":"Vis medlemskab %{id}"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;